import { useMutation } from '@tanstack/react-query'
import axios from 'axios'
import config from '../../config'
import { IWorkOrder, IWorkOrderAddUpsert, IUseAddMutation } from '../../interfaces'

export type IWorkOrderOnHazardAddUpsert = IWorkOrderAddUpsert & { hazardId: number }

const useCreateWorkOrderOnHazardMutation: IUseAddMutation<IWorkOrder, IWorkOrderOnHazardAddUpsert> = (
  params,
  options = {},
) => {
  return useMutation<IWorkOrder, Error, IWorkOrderOnHazardAddUpsert>({
    mutationFn: async data => {
      const { hazardId, ...workOrderAddUpsert } = data
      const url = `${config.baseUrl}/${params?.airportId}/WorkOrders/OnHazard/${hazardId}`
      const res = await axios({ method: 'post', url, data: workOrderAddUpsert })
      return res.data
    },
    ...options,
  })
}

export default useCreateWorkOrderOnHazardMutation
